export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    SYS_SERVICE_ALL: function SYS_SERVICE_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/sms-service/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    SYS_SERVICE_CREATE: function SYS_SERVICE_CREATE(data) {
      return request({
        url: '/api/sms-service/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SYS_SERVICE_DETAIL: function SYS_SERVICE_DETAIL(id) {
      return request({
        url: '/api/sms-service/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    SYS_SERVICE_UPDATE: function SYS_SERVICE_UPDATE(data) {
      return request({
        url: '/api/sms-service/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    SYS_SERVICE_DELETE: function SYS_SERVICE_DELETE(id) {
      return request({
        url: '/api/sms-service/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});